module.exports = __webpack_public_path__ + "static/remarketing-dbcf089d5ee80feeb167799486b21280.jpg";